import React from "react";
import { Routes, Route, Link } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import JSCompiler from "./JavaScriptCompiler/JSCompiler";
import ViewQRData from "./ViewQRCode/ViewQRData";
import Login from "./Login/Login";

function App() {
  return (
    <div>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/landing" element={<JSCompiler />} />
        <Route path="/view" element={<ViewQRData />} />
      </Routes>
    </div>
  );
}

export default App;
